import React from "react";
import { Link } from "react-router-dom";
import { subServices } from "../../../Data/services";

const ServicesMegaMenu = () => {
  return (
    <>
      <div className="z-50">
        <div>
          <div
            className="w-4 h-4 left-3 absolute 
 mt-1 bg-white rotate-45"
          ></div>
        </div>
        <div
          style={{ boxShadow: "0px 0px 15px 0px rgb(0 0 0 / 15%)" }}
          className="bg-[#fff] font-roboto rounded-b z-50 px-5 py-4  grid grid-cols-2 gap-5 "
        >
          <div>
            <h2 className="text-lg font-semibold text-[#101130]">
              Digital Marketing
            </h2>

            {subServices.slice(0, 5).map((service) => (
              <li key={service._id} className="text-sm text-gray-600 my-2.5">
                <Link
                  to={`/categories/${service.slug}`}
                  className="hover:text-primary font-medium text-xs"
                >
                  {service.title}
                </Link>
              </li>
            ))}
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[#101130]">
              Graphics & Design
            </h2>

            {subServices.slice(5, 10).map((service) => (
              <li key={service._id} className="text-sm text-gray-600 my-2.5">
                <Link
                  to={`/categories/${service.slug}`}
                  className="hover:text-primary font-medium text-xs"
                >
                  {service.title}
                </Link>
              </li>
            ))}
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[#101130]">
              Programming & Tech
            </h2>

            {subServices.slice(10, 15).map((service) => (
              <li key={service._id} className="text-sm text-gray-600 my-2.5">
                <Link
                  className="hover:text-primary font-medium text-xs"
                  to={`/categories/${service.slug}`}
                >
                  {service.title}
                </Link>
              </li>
            ))}
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[#101130]">
              Writing & Translation
            </h2>

            {subServices.slice(15, 20).map((service) => (
              <li key={service._id} className="text-sm text-gray-600 my-2.5">
                <Link
                  className="hover:text-primary font-medium text-xs"
                  to={`/categories/${service.slug}`}
                >
                  {service.title}
                </Link>
              </li>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicesMegaMenu;
